<template>
  <div class="page" @click="handleClose">
    <div class="mask"></div>
    <div class="popup">
      <!-- 弹窗背景 -->
      <div class="popup-bg">
        <img
          :src="require('@/assets/images/YuliApp/weeklyTask/pop_bg@2x.png')"
        />
      </div>

      <!-- 烟花 -->
      <div class="popup-flower-bg flower-fade">
        <img
          :src="
            require('@/assets/images/YuliApp/weeklyTask/bg_pop_move@2x.png')
          "
        />
      </div>

      <div class="popup-bgtitle">Claim Rewards</div>
      <div class="popup-title">{{ title }}</div>
      
      <!-- 奖励内容 -->
      <slot></slot>

      <div class="popup-button" @click="handleClose">
        <img src="@/assets/images/YuliApp/weeklyTask/popup_close.png" />
      </div>

      <!-- 三个星星 -->
      <img
        class="star1"
        :src="
          require('@/assets/images/YuliApp/weeklyTask/img_light1_thunder@2x.png')
        "
      />
      <img
        class="star2"
        :src="
          require('@/assets/images/YuliApp/weeklyTask/img_light1_thunder@2x.png')
        "
      />
      <img
        class="star3"
        :src="
          require('@/assets/images/YuliApp/weeklyTask/img_light1_thunder@2x.png')
        "
      />
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { DRAW_CLICK_TYPE } from "@/constants/enums";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  watch: {},
  setup(props, ctx) {
    const popup_info = ref(null);

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close", false);
    };
    return {
      handleClose,
      popup_info,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    animation: maskFade 0.15s ease-in-out both;
  }
  @keyframes maskFade {
    0% {
      background: rgba(0, 0, 0, 0);
    }
    100% {
      background: rgba(0, 0, 0, 0.8);
    }
  }
  .popup {
    position: absolute;
    z-index: 9999;
    width: 100%;
    // height: 264px;
    height: 375px;
    top: 20%;
    text-align: center;
    // background: url("~@/assets/images/YuliApp/weeklyTask/pop_bg@2x.png")
    //   no-repeat top left;
    // background-size: 100% 100%;
    &-bg {
      width: 100%;
      height: 375px;
      animation: bgfade 0.3s ease-in-out both;
      img {
        width: 100%;
        height: 100%;
      }
    }
    @keyframes bgfade {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    &-flower-bg {
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0.8;
      width: 300px;
      height: 300px;
      animation: flower 0.6s ease both, flowerFade 0.1s ease both 0.2s;
      // animation-fill-mode: both;
      // animation: flower 1.6s ease-in-out infinite alternate;
      img {
        width: 100%;
        height: 100%;
      }
    }

    @keyframes flower {
      0% {
        transform: translate(-50%, -50%) scale(1);
      }
      100% {
        transform: translate(-50%, -50%) scale(3);
      }
    }

    @keyframes flowerFade {
      0% {
        opacity: 0.6;
      }
      100% {
        opacity: 0;
      }
    }
    &-bgtitle {
      position: absolute;
      top: 26px;
      left: 50%;
      transform: translate(-50%, 0);
      color: rgba(255, 255, 255, 1);
      font-size: 30px;
      font-weight: 700;
      font-family: "Josefin Sans SemiBold";
      text-align: center;
      letter-spacing: -2.1px;
      text-shadow: rgba(230, 202, 59, 0.83) 4.57px 4.57px 4.57px;

      text-stroke: 1px rgba(255, 172, 75, 1);
      /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
      -webkit-text-stroke: 1px rgba(255, 172, 75, 0.3);
      white-space: nowrap;
    }
    &-title {
      position: absolute;
      top: 85px;
      left: 50%;
      transform: translate(-50%, 0);
      height: 25px;
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      font-weight: 700;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 25px;
    }
    &-button {
      position: relative;
      z-index: 999;
      margin: 0 auto;
      margin-top: 50px;
      width: 42px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .star1 {
      position: absolute;
      top: 100px;
      left: 10%;
      width: 13px;
      height: 13px;
      animation: starScale 1s ease-in-out infinite alternate;
    }
    .star2 {
      position: absolute;
      top: 130px;
      right: 10%;
      width: 13px;
      height: 13px;
      animation: starScale 1s ease-in-out infinite alternate 0.8s;
      // animation-delay: 0.8s;
    }
    .star3 {
      position: absolute;
      top: 260px;
      right: 25%;
      width: 13px;
      height: 13px;
      animation: starScale 1s ease-in-out infinite alternate 1.7s;
      // animation-delay: 1.7s;
    }

    @keyframes starScale {
      0% {
        transform: scale(0.1);
      }
      100% {
        transform: scale(1);
      }
    }

    @keyframes star1Move {
      0% {
        top: 50%;
        left: 50%;
      }
      100% {
        top: 100px;
        left: 10%;
      }
    }
    @keyframes star2Move {
      0% {
        top: 50%;
        right: 50%;
      }
      100% {
        top: 130px;
        right: 10%;
      }
    }
    @keyframes star3Move {
      0% {
        top: 50%;
        right: 50%;
      }
      100% {
        top: 260px;
        right: 25%;
      }
    }
  }
}
</style>
